module.exports = __webpack_public_path__ + "img/index2.79ff81a5.webp";